import { createLogger } from 'redux-logger';
import unwrap from './unwrap'
// export const sagaMiddleware = createSagaMiddleware();

const middleware = [unwrap];

if (process.env.NODE_ENV === 'development') {
  middleware.push(createLogger({ collapsed: true }));
}

export default middleware;
